
//Dependencies
import React, { Component } from 'react';

//material-ui
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

//Assets
import calculator from '../../../static/img/calculator.png';
import curriculum from '../../../static/img/curriculum.png';
import money from '../../../static/img/money.png';

class Description extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div className="description">
                <Grid container>
                    <Grid item xs={12} className="description-title">
                        ¡Es fácil y rápido!
                        </Grid>
                </Grid>
                <Grid container className="description-detail">
                    <Grid item xs={12} sm={12} md={4} className={classes.padding}>
                        <img src={calculator} className="calculator" />
                        <Grid item xs={12} className="detail">
                            <strong>Simulá</strong> tu Plazo Fijo.
                            </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} className={classes.padding}>
                        <img src={curriculum} className="curriculum" />
                        <Grid item xs={12} className="detail" >
                            <strong>Completá</strong> el formulario <br />con tus datos.
                            </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} className={classes.padding}>
                        <img src={money} className="money" />
                        <Grid item xs={12} className="detail">
                            <strong>Confirmá</strong> la operación  <br />en tu otro banco.
                            </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

//THEME
const styles = theme => ({
    padding: {
        padding: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(Description);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/landingPage/Description.js